/* eslint-disable max-lines-per-function */
/**
 * @file Upcoming 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import BaseCard from '~/component/BaseCard';

import './index.less';

function Upcoming({data: {contentResponseList}}) {
    const history = useHistory();

    function handleDetail(uid) {
        history.push(`/news/detail/${uid}?type=upcoming-event`);
    }
    function handleClick() {
        history.push('/news/events');
    }
    return (
        <div className="upcoming-container">
            <BaseCard title="Upcoming Events" onClick={handleClick} isConfig={false}>
                {
                    contentResponseList.map(item => (
                        <div key={item.id} className="upcoming-events">
                            <div
                                className="upcoming-content"
                                // eslint-disable-next-line
                                onClick={() => handleDetail(item.uid)}
                                role="button"
                                tabIndex={0}
                            >
                                {item.content.title}
                            </div>
                            <div className="upcoming-time">
                                {`${item.content.date} ${item.content.time}`}
                                {' '}
                                {item.content.timeZone}
                            </div>
                        </div>
                    ))
                }
            </BaseCard>
        </div>
    );
}

export default Upcoming;
